<template>
  <section class="catalog_main_outer">
    <div class="container flx">
      <catalog-aside></catalog-aside>
      <div class="catalog_main_inner">
        <category-filter
          :size-items="sizes"
          :selected-size.sync="selected_size"
          :color-items="colors"
          :selected-color.sync="selected_color"
          :price-items="prices"
          :selected-price-from.sync="selected_price_from"
          :selected-price-to.sync="selected_price_to"
          @clear-filters="clearCatalogFilters"
          @change-filter="getProducts()"
        ></category-filter>
        <div class="product_card_wrap flx" style="justify-content: start">
          <product-card v-for="item in products" :key="'product-card-'+item.product_color_id" :product="item" slider-key="catalog"></product-card>
          <show-more-products :per-page="perPage" @click:show-more="addProducts" v-if="showBtnShowMore()"></show-more-products>
        </div>
        <paginate
          v-model="current_page"
          :pageCount="meta.last_page"
          :clickHandler="setPaginationPage"
          :prevText="'Предыдущая'"
          :nextText="'Следующая'"
          :containerClass="'pagination_category flx'"
          :prev-link-class="'preview angle'"
          :next-link-class="'next angle'"
          page-link-class="item"
          active-class="active"
          no-li-surround
        >
        </paginate>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import CatalogAside from './CatalogAside'
import CategoryFilter from '../../Catalog/CategoryFilter'
import ProductCard from '../../Product/ProductCard'
import ShowMoreProducts from '../../Pagination/ShowMoreProducts'
export default {
  name: 'CatalogMain',
  components: {
    CatalogAside,
    CategoryFilter,
    ProductCard,
    ShowMoreProducts
  },
  computed: {
    ...mapState('catalog', ['sizes', 'size', 'colors', 'color', 'prices', 'price_from', 'price_to', 'perPage']),
    ...mapState('products', ['products', 'meta']),
    ...mapGetters('products', ['showBtnShowMore']),
    selected_size: {
      get () {
        return this.size
      },
      set (val) {
        this.setSize(val)
      }
    },
    selected_color: {
      get () {
        return this.color
      },
      set (val) {
        this.setColor(val)
      }
    },
    selected_price_from: {
      get () {
        return this.price_from
      },
      set (val) {
        this.setPriceFrom(val)
      }
    },
    selected_price_to: {
      get () {
        return this.price_to
      },
      set (val) {
        this.setPriceTo(val)
      }
    },
    current_page: {
      get () {
        return this.meta.current_page
      },
      set (val) {
        this.setPaginationPage(val)
      }
    }
  },
  methods: {
    ...mapMutations('catalog', ['setSize', 'setColor', 'clearFilters', 'setPriceFrom', 'setPriceTo', 'setPage', 'setCategoriesIds', 'clearCurrentCategory']),
    ...mapActions('catalog', ['getSizes', 'getColors', 'getCurrentCategory']),
    ...mapActions('products', ['getProducts', 'addProducts']),
    prepare () {
      this.getSizes()
      this.getColors()
      this.clearFilters()
      // this.clearCatalogFilters()
      this.current_page = parseInt(this.$route.query.page, 10) || 1
      const categories = this.$route.query.categories
      if (categories) {
        const catIds = this.$route.query.categories.split(',')
        this.setCategoriesIds(catIds.map(id => parseInt(id)) || [])
        if (catIds.length === 1) {
          this.getCurrentCategory(parseInt(catIds[0]))
        } else {
          this.clearCurrentCategory()
        }
      }
    },
    clearCatalogFilters () {
      this.clearFilters()
      this.getProducts()
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (to, from) {
        const categories = to.query.categories

        if (categories) {
          const catIds = to.query.categories.split(',')
          console.log('categories ' + catIds.map(id => parseInt(id)))
          this.setCategoriesIds(catIds.map(id => parseInt(id)) || [])
        } else {
          this.setCategoriesIds([])
        }
        this.setPage(to.query.page || 1)
        this.$nextTick(() => {
          this.getProducts()
        })
      }
    }
  },
  created () {
    this.prepare()
  }
}
</script>

<style scoped>

</style>
